<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    multiple
    chips
    deletable-chips
    small-chips
    item-text="nome"
    item-value="id"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:append-outer>
      <slot name="append-outer"/>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CompradorService from '@/api/comprador-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

const emptyUser = () => ({
  id: 0,
  nome: 'Sem responsável',
});

export default {
  props: {
    value: [Object, Array],
    roles: {
      type: Array,
      default() {
        return ['ROLE_APROVADOR_COMPRAS'];
      },
    },
    label: {
      type: String,
      default: 'Usuário',
    },
    showEmptyUser: {
      type: Boolean,
      default: false,
    },
    fetchOnFocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.nome === val)) return;
      this.debounceSearch(val);
    },
    value() {
      if (this.value) {
        this.items = [...this.items, ...this.value];
      }
    },
  },
  methods: {
    buildQuery(val) {
      let query = `(nome like "%${val}%")`;

      if (this.roles && this.roles.length) {
        query += ` and role in ('${this.roles.join("', '")}')`;
      }

      return query;
    },
    searchData(val) {
      const searchVal = val || '';

      this.loading = true;

      CompradorService.getUsuarios({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildQuery(searchVal.toLowerCase()),
      })
        .then((response) => {
          this.items = response.data.content;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
          if (this.showEmptyUser) {
            this.items.push(emptyUser());
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
      this.$emit('focus');
      if (this.fetchOnFocus && !this.items.length) {
        this.searchData();
      }
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchData, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
